// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__Xc6WQ","title":"AfterFrontImage_title__1aC4d"};